import React, { useContext, useEffect, useState } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import {
    UiButton,
} from "../../../../_uiComponents/common/form/UiButton";
import UiDropDownList from '../../../../_uiComponents/telerikComponents/UiDropDownList';
import { useDispatch, useSelector } from 'react-redux';
import { contextApiActions, participantConstants } from '../../../../../_redux/_constants';
import { participantGetRolesRequest, participantUpdateDealerRequest, participantUpdateJobRoleRequest } from '../../../../../_redux/_actions';
import { Context } from '../../../../../_context/Store';

export default function TransferJobRole(props) {

    const actionDispatch = useDispatch();

    const { jobRoleList } = useSelector((state) => ({
        jobRoleList: state?.participantsManagement?.jobRoleList,
    }));

    useEffect(() => {
        if(props?.currentJobRole?.application === participantConstants.PARTICIPANT_APPLICATION_EQUIPE){
            actionDispatch(participantGetRolesRequest({ applicationId: 1 }));
        }if(props?.currentJobRole?.application === participantConstants.PARTICIPANT_APPLICATION_TLC){
            actionDispatch(participantGetRolesRequest({ applicationId: 3 }));
        }
    },[props]);

    const [jobRole, setJobRole] = useState(null);
    const [state, dispatch] = useContext(Context);

    const dealerValidator = value => value ? '' : 'Dealer is required.';

    const handleSubmit = dataItem => {
        
        actionDispatch(participantUpdateJobRoleRequest({
            ParticipantId:props?.currentDealer?.id,
            JobRoleId:dataItem?.currentJobRole?.value
        }));

        dispatch({
            type: contextApiActions.UI_MODAL_TOGGEL,
            payload: {
                show: false,
            }
        })
    };

    return (
        <> 
            <Form onSubmit={handleSubmit}
                render={formRenderProps =>
                    <Grid container spacing={2}>
                        <div className="sba-input-areas-wr">
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-dealer-label'>
                              <span><label>Current Job Role</label> 
                              <label>{`${props?.currentJobRole?.jobRole}`}</label>
                              </span>  
                            </Grid>
                        </Grid>
                        {jobRoleList.length > 0 && (
                            <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                            <Field name={'newJobRole'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={jobRoleList
                                            .filter((app) => app.name !== props?.currentJobRole?.jobRole)
                                            .map((app) => ({
                                                value: app.id.toString(),
                                                label: app.name,
                                            }))
                                        }
                                        label="New Job role"
                                        validator={dealerValidator}
                                        value={jobRole}
                                        onChange={(e) => setJobRole(e.value?.value)} />

                            </Grid>
                        )}
                            <Grid item xs={12}>
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ width: "100%", mt: 1.5 }}
                                >
                                    <div className="sbt-right-action-btn-wr">                                  
                                        <UiButton
                                                name="Cancel"
                                                variant="outlined"
                                                size="small"
                                                onClick={formRenderProps.onFormReset}
                                            />
                                        <UiButton
                                            name="Transfer"
                                            variant="contained"
                                            size="small"
                                            onClick={formRenderProps.onSubmit}
                                            disabled={!formRenderProps.allowSubmit}
                                        />

                                    </div>
                                </Stack>
                            </Grid>
                        </div>
                    </Grid>
                }
            />
        </>
    )
}
